// extracted by css-extract-rspack-plugin
export default {"aliceAppActionButton":"aliceAppActionButton__l9Jup"};